<template>

    <div class="app-block app-application">
        <div>
            <transition name="component-fade" mode="out-in">
                <component
                        class="choices-block"
                        :is="choiceView"
                        :school="school"
                        :campuses="campuses"
                        :trainings="trainings"
                        :choices="application.choices"
                        :candidate="candidate"
                        :application="application"
                        :completion="completion">
                </component>
            </transition>
            <div>

            <div v-if="application.motivation_complete">
                <transition name="component-fade" mode="out-in">
                    <component
                            class="motivation-block"
                            :is="motivationView"
                            :school="school"
                            :candidate="candidate"
                            :application="application">
                    </component>
                </transition>
            </div>


                <div v-if="application.documents_complete">
                    <transition name="component-fade" mode="out-in">
                        <component
                                class="documents-block"
                                :is="documentsView"
                                :school="school"
                                :candidate="candidate"
                                :application="application">
                        </component>
                    </transition>
                </div>


                <transition name="component-fade" mode="out-in">
                    <component
                            id="payment"
                            class="fees-block"
                            :is="feesView"
                            :school="school"
                            :candidate="candidate"
                            :application="application"
                            :errorFee="errorFee">
                    </component>
                </transition>

               <!-- <transition name="component-fade" mode="out-in">
                    <component
                            class="registration-block"
                            :disabled="!applicationAccepted()"
                            :is="registrationView"
                            :candidate="candidate"
                            :application="application"
                            :school="school">
                    </component>
                </transition>-->

                <transition name="component-fade" mode="out-in">
                    <component
                            class="messages-block"
                            :is="applicationDocumentsView"
                            :candidate="candidate"
                            :application="application"
                            :school="school">
                    </component>
                </transition>

            </div>
        </div>


    </div>

</template>

<script>
    import Choices from './Choices.vue'
    import Curriculum from './Curriculum.vue'
    import Motivation from './Motivations.vue'
    import Fees from './Fees.vue'
    import Documents from './Documents.vue'
    import ApplicationDocuments from './ApplicationLogDocuments.vue'
    import Process from './Process.vue'
    import RegistrationFees from './RegistrationFees.vue'
    import {mapActions, mapGetters, mapState} from 'vuex'

    export default {
        data () {
            return {
                isLoaded: false,
                completion: 100,
                choiceView: '',
                motivationView: '',
                feesView: '',
                documentsView: '',
                applicationDocumentsView: ApplicationDocuments,
                processView: '',
                registrationView: '',
                messageView: '',
                selectedApplication: {},
                choices: [],
                family: {},
                campuses: [],
                trainings: [],
                errorFee: '',
                applicationProcess: '',
                d1: {
                    v: false,
                    styles: [
                        {},
                        {
                            paddingBottom: '1rem'
                        },
                        {},
                        {
                            color: '#555',
                            textDecoration: 'none',
                            top: '1rem',
                            left: '0.1rem'
                        }
                    ],
                },

            }
        },
        props: {
            school: {type: Object},
            candidate: {type: Object},
            application: {type: Object}
        },
        computed: {
            ...mapState({
                user: 'auth',
                responsive: 'app'
            }),
            ...mapGetters('organization', [
                'currentScholarYear'
            ])
        },

        methods: {
            ...mapActions({
                refreshAccount: 'auth/setAccount',
                logout: 'auth/logout'
            }),
            ...mapActions('organization', [
                'fetchSchools'
            ]),
            ...mapActions('candidate', [
                'selectApplication'
            ]),

            choicesComplete () {
                return this.application && this.application.choices_complete
            },
            feesComplete () {
                return this.application && this.application.fees_complete
            },
            applicationAccepted () {
                return this.application && this.application.accepted
            },
            notAuthenticated () {
                this.$router.replace({ 'path': '/admissionsup/' + this.school + '/connexion' })
                this.logout()
            },

            getCandidate: function () {

                this.choices = []
                if (this.application.choices && this.application.choices.length > 0) {
                    this.choices = this.application.choices
                }

                this.choiceView = Choices
                this.motivationView = Motivation
                this.feesView = Fees
                this.documentsView = Documents
                this.processView = Process
                this.registrationView = RegistrationFees

            }
        },
        created () {
            this.getCandidate()
        }
    }
</script>

<style scoped>
    .app-application {
        padding-bottom: 10px;
    }

    .application-procedure {
        font-weight: 600;
    }

    .school-button-ednh {
        color: #fff;
        background-color: #00b4ec;
    }

    .school-button-egpn {
        color: #fff;
        background-color: #84b23c;
    }

    .school-button-coursdiderot {
        color: #fff;
        background-color: #FF9C3F;
    }

    .school-button-ibs {
        color: #fff;
        background-color: #0067B7;
    }

    .school-button-ensia {
        color: #fff;
        background-color: #009ee0;
    }

</style>
